module.exports = __webpack_public_path__ + "public/images/tariffs/radio-active.9e6fd79f61b2f64911aee32ef377a998.svg";